module.exports = __webpack_public_path__ + "static/media/userIcon.36dc4daa.svg";